import axios from 'axios';
import Api from './Api';

const { CancelToken } = axios;

let cancelRead;
class InventoryPoApi extends Api {
  constructor() {
    super('inventory-pos', 'inventory-pos');
  }

  async readData(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }
}
const inventoryPoApi = new InventoryPoApi();

export default inventoryPoApi;
